import styled from 'styled-components';

const Container = styled.div`
  position: relative;
`;

const Radio = styled.input(({ theme }) => {
  const { color } = theme;

  return `
    position: absolute;
    left: -9999px;
    top: 0;

    & + label {
      position: relative;
      padding: 0 10px 0 25px;

      &::before {
        display: block;
        content: '';
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 18px;
        height: 18px;
        border: 1px solid ${color.grayscale[600]};
        border-radius: 50%;
        cursor: pointer;
      }
    }

    &:checked + label::before {
      border: 5px solid ${color.primary.regular};
    }

    &:focus-visible + label::before {
      outline: 2px auto -webkit-focus-ring-color;
    }

    &:disabled {
      & + label::before {
        cursor: default;
        background-color: ${color.grayscale[800]};
      }
  
      &:checked + label::before {
        border: 5px solid ${color.grayscale[600]};
      }
    }
  `;
});

const RadioButton = ({ checked, label, name, value, disabled, onChange }) => {
  return (
    <Container>
      <Radio
        id={`${name}_${value}`}
        name={name}
        type="radio"
        key={`${name}_${value}`}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <label htmlFor={`${name}_${value}`} key={`${name}_${value}_label`}>
        {label}
      </label>
    </Container>
  );
};

export default RadioButton;
